import { render, staticRenderFns } from "./LeftoversList.vue?vue&type=template&id=1b9a2ba6&scoped=true&"
import script from "./LeftoversList.vue?vue&type=script&lang=js&"
export * from "./LeftoversList.vue?vue&type=script&lang=js&"
import style0 from "./LeftoversList.vue?vue&type=style&index=0&id=1b9a2ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a2ba6",
  null
  
)

export default component.exports